module.exports = __webpack_public_path__ + "img/icon_centralizacao_de_comunicacoes.28db24d3.png";